export default "__VITE_ASSET__BUoyEB5l__"